import axios from 'axios';
import MessageFilterRequest from '../entity/message-filter.request';
import MessageRequest from '../entity/message.request';

export interface SendMessageParams {
  message: string;
  videoTittle?: string;
  videoUrl?: string;
}

export default class MicrosoftService {
  public static sendMessage(
    params: SendMessageParams,
    filter: MessageFilterRequest,
  ): Promise<void> {
    return axios.post('/api/microsoft-graph/message', {
      message: new MessageRequest(params.message, params.videoTittle, params.videoUrl),
      filters: {
        employees: filter.hasField('employees') ? filter.employees : null,
        admissionStartDate: filter.hasField('admissionStartDate') ? filter.admissionStartDate : null,
        admissionEndDate: filter.hasField('admissionEndDate') ? filter.admissionEndDate : null,
        toManagers: filter.toManagers,
        indirectSubordinates: filter.indirectSubordinates,
        managers: filter.hasField('managers') ? filter.managers : null,
        businessUnits: filter.hasField('businessUnits') ? filter.businessUnits : null,
        resultCenters: filter.hasField('resultCenters') ? filter.resultCenters : null,
        roles: filter.hasField('roles') ? filter.roles : null,
        workplaces: filter.hasField('workplaces') ? filter.workplaces : null,
        gender: filter.hasField('gender') ? filter.gender : null,
        cities: filter.hasField('cities') ? filter.cities : null,
        states: filter.hasField('states') ? filter.states : null,
        countries: filter.hasField('country') ? [filter.country] : null,
        hasChildren: filter.hasChildren,
        foreignState: filter.hasField('foreignState') ? filter.foreignState : null,
      },
      timeout: Infinity,
    })
  }
}
